module.exports = "/_next/static/images/img__statistic-6964109bd3479d880991bdb306a473cc.png";